import { render, staticRenderFns } from "./ujian_old.vue?vue&type=template&id=98b07674&"
import script from "./ujian_old.vue?vue&type=script&lang=js&"
export * from "./ujian_old.vue?vue&type=script&lang=js&"
import style0 from "./ujian_old.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports